import { useDynamicLocation } from "apps/commons/hooks/useDynamicLocation";
import { useEffect } from "react";
import { initializeGtm } from "./gtm";
import { getPageTypeId } from "./mappers/pageTypeIdMapper";

export const useGtm = () => {
    const { pathname } = useDynamicLocation();

    useEffect(() => {
        void initializeGtm(getPageTypeId(pathname));
    }, [pathname]);
};
